<div class="flex flex-col mb-4 relative">
  @if(label){
  <label [for]="label" class="mb-1 font-medium text-gray-800">{{ label }}</label>
  }

  <div class="relative group">
    <input
      [id]="label"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
      class="w-full px-4 py-1.5 rounded-md border outline-none transition-all duration-300
        focus:border-blue-500 focus:shadow-sm
        placeholder:text-gray-400
        disabled:bg-gray-100
        {{ error ? 'border-red-500 pr-10' : value ? 'border-green-500 pr-10' : 'border-gray-300' }}"
    />


    @if(!error && value){
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="absolute right-2 top-[20px] -translate-y-1/2 h-5 w-5 text-green-500 transition-all duration-300 ease-out scale-100 opacity-100"
      [ngClass]="{ 'scale-100 opacity-100': value, 'scale-0 opacity-0': !value }"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
    </svg>
    }

    @if(error){
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="absolute right-2 top-[21.5px] -translate-y-1/2  h-4 w-4 text-red-500 transition-all duration-300 ease-out scale-100 opacity-100"
      [ngClass]="{ 'scale-100 opacity-100': error, 'scale-0 opacity-0': !error }"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>

    <small class="text-red-500 text-sm mt-1 block animate-fadeIn">{{ error }}</small>
    }
  </div>
</div>
